// 🎯 10 ANA KATEGORI
export const CATEGORIES = {
  HISTORY: {
    id: 1,
    name: 'Tarih',
    description: 'Dünya tarihi, medeniyetler, savaşlar, önemli olaylar',
    color: '#e74c3c',
    icon: '🏛️'
  },
  GEOGRAPHY: {
    id: 2,
    name: 'Coğrafya',
    description: 'Ülkeler, şehirler, dağlar, nehirler, harita bilgisi',
    color: '#3498db',
    icon: '🗺️'
  },
  SCIENCE: {
    id: 3,
    name: 'Bilim',
    description: 'Fizik, kimya, biyoloji, astronomi',
    color: '#9b59b6',
    icon: '🔬'
  },
  ART_LITERATURE: {
    id: 4,
    name: 'Sanat ve Edebiyat',
    description: 'Ressamlar, yazarlar, klasik ve modern eserler',
    color: '#e67e22',
    icon: '🎨'
  },
  MUSIC: {
    id: 5,
    name: 'Müzik',
    description: 'Besteciler, şarkıcılar, müzik türleri',
    color: '#1abc9c',
    icon: '🎵'
  },
  SPORTS: {
    id: 6,
    name: 'Spor',
    description: 'Futbol, olimpiyatlar, sporcular, tarihçe',
    color: '#2ecc71',
    icon: '⚽'
  },
  CINEMA_TV: {
    id: 7,
    name: 'Sinema ve Televizyon',
    description: 'Filmler, yönetmenler, ödüller',
    color: '#f1c40f',
    icon: '🎬'
  },
  TECHNOLOGY: {
    id: 8,
    name: 'Teknoloji',
    description: 'Buluşlar, icatlar, internet ve yazılım bilgisi',
    color: '#00cbd2',
    icon: '💻'
  },
  GENERAL_CULTURE: {
    id: 9,
    name: 'Genel Kültür ve Güncel Bilgiler',
    description: 'Güncel olaylar, popüler kültür',
    color: '#95a5a6',
    icon: '🌍'
  },
  MYTHOLOGY_RELIGION: {
    id: 10,
    name: 'Mitoloji ve Dinler',
    description: 'Mitler, inançlar, dini ritüeller',
    color: '#d35400',
    icon: '⚡'
  }
} as const;